import {PivotalApiBase} from "./PivotalApiBase";

export default class PivotalTaskApi extends PivotalApiBase {

  constructor(baseUrl, apiEnv, apiToken) {
    super(baseUrl, apiEnv, apiToken);
  }

  callTaskEndpoint(requestData, envSplit) {
    return this._fetchPostRequest('/rest/serverTasks/actions/execute', requestData, envSplit);
  }

}
